import memberInfo from '@/utils/memberInfo';
import ssoService from '@/services/ssoService';
import mbcService from '@/services/mbcService';
import pmtService from '@/services/pmtService';
import thirdPartyService from '@/services/thirdPartyService';
import sctService from '../services/sctService';

export default {
  namespaced: true,
  state: {
    accountID: '',
    accountType: '',
    identifySource: '',
    normalRegrType: '',
    userVerifyType: '',
    updatePassword: false,
    updateAddress: false,
    models: [],
    customModels: [],
    answers: [],
    customAnswers: [],
    trdLoginData: null,
    verifierAccount: undefined,
    doVerifierAccount: false,
    callingVerifierAccount: false,
    continueDoSaveData: false,
    validatePasswordDone: true,
    callPutCustomerdataupdateDone: true,
    countrys: [],
    twCityList: [],
    cnProvinceList: [],
    memberAccount: null,
    originalAnswerSnapshot: '',
    customerData: [],
    eticketTypeForWriteOff: null,
    eticketNoForWriteOff: null,
    eticketNameForWriteOff: '',
    isWriteOffClick: false,
    isTransfer: false,
    eticketSeqNoForWriteOff: null,
    eticketImg: '',
    eticketDesc: '',
    companyName: '',
    eticketIsNeedWriteoffCode: false,
  },
  getters: {
    // 檢查表單答案是否有被異動過
    isAnswerChanged(state) {
      // 若無快照紀錄，直接判斷為未做過異動
      if (!state.originalAnswerSnapshot) return false;
      const answerJson = JSON.stringify(state.answers);
      const customAnswersJson = JSON.stringify(state.customAnswers);
      const currentAnswerSnapshot = `${answerJson},${customAnswersJson}`;
      return state.originalAnswerSnapshot !== currentAnswerSnapshot;
    },
  },
  mutations: {
    setMemberSourceData(state, data) {
      state[data.id] = data.value;
    },
    setAnswers(state, data) {
      state.answers = [];
      state.answers.push({ id: 'Name', value: data.realName });
      state.answers.push({ id: 'Nickname', value: data.name });
      state.answers.push({ id: 'Gender', value: data.gender });
      state.answers.push({ id: 'PersonalID', value: data.personalID });
      state.answers.push({ id: 'EMail', value: data.email });
      state.answers.push({ id: 'Birthday', value: data.birth.replace(/\//g, '-') });
      if (data.country === 'TW') {
        data.city = data.city.replace(/台/, '臺');
      }
      const address = {
        zipCode: data.zipCode,
        country: data.country,
        province: data.province,
        city: data.city,
        district: data.district,
        address: data.address,
      };
      state.answers.push({ id: 'Address', value: address });
      const mobile = {
        mobileCountry: data.mobileCountry,
        callingCode: data.callingCode,
        mobile: data.mobile,
      };
      state.answers.push({ id: 'Mobile', value: mobile });
      state.customAnswers = data.custom;
    },
    updateAnswer(state, data) {
      if (state.answers.find((d) => d.id === data.id)) {
        state.answers.find((d) => d.id === data.id).value = data.value;
      } else {
        state.answers.push({ id: data.id, value: data.value });
      }
    },
    updateCustomAnswer(state, data) {
      if (state.customAnswers.find((d) => d.customQuestionID === data.id)) {
        state.customAnswers.find((d) => d.customQuestionID === data.id).paramValue = data.value;
      } else {
        state.customAnswers.push({ customQuestionID: data.id, paramValue: data.value });
      }
    },
    setOriginalAnswerSnapshot(state) {
      const answerJson = JSON.stringify(state.answers);
      const customAnswersJson = JSON.stringify(state.customAnswers);
      state.originalAnswerSnapshot = `${answerJson},${customAnswersJson}`;
    },
    clearOriginalAnswerSnapshot(state) {
      state.originalAnswerSnapshot = '';
    },
  },
  actions: {
    // 產生 digest
    getDigest({ rootState }, body) {
      return ssoService.getDigest(rootState.companyId, rootState.memberSourceId, body).toPromise();
    },
    // 取得會員帳號資料
    getMemberAccount({ commit, state, rootState }, needGetAllAccount = false) {
      // 若state中沒有會員帳號資料的promise，呼叫API
      if (!state.memberAccount) {
        const headers = { accessToken: rootState.accessToken };
        const param = { companyID: rootState.companyId };

        // 是否需取得所有會員帳號
        if (needGetAllAccount) {
          param.isGetAll = true;
        }

        const memberSourceSetting = ssoService.getMemberSourceSetting({ companyID: rootState.companyId, memberSourceID: rootState.memberSourceId })
          .toPromise();

        const memberAccount = mbcService.getMemberAccount(param, headers)
          .toPromise();

        return Promise.all([memberSourceSetting, memberAccount]).then(([settingRes, accountRes]) => {
          if (settingRes.response.success && accountRes.response.success) {
            const setting = settingRes.response.data[0];
            const accounts = accountRes.response.data[0].account;

            let account;
            // 嘗試找出特定的帳號，找不到用原邏輯做顯示
            switch (setting.normalRegrType) {
              case 'Email':
                account = accounts.find((x) => x.accountType === 'Email') || accountRes.response.data[0].account[0];
                break;
              case 'Mobile':
                account = accounts.find((x) => x.accountType === 'Mobile') || accountRes.response.data[0].account[0];
                break;
              default:
                // eslint-disable-next-line prefer-destructuring
                account = accountRes.response.data[0].account[0];
                break;
            }

            // 設定帳號註冊類型
            commit('setMemberSourceData', { id: 'normalRegrType', value: setting.normalRegrType });
            // 設定帳號忘記密碼或註冊驗證的方式
            commit('setMemberSourceData', { id: 'userVerifyType', value: setting.userVerifyType });
            // 設定帳號類別
            commit('setMemberSourceData', { id: 'accountType', value: account.accountType });
            // 設定 identifySource
            commit('setMemberSourceData', { id: 'identifySource', value: account.identifySource });
            // 設定 accountID
            commit('setMemberSourceData', { id: 'accountID', value: account.accountID });
          }

          commit('setMemberSourceData', { id: 'memberAccount', value: accountRes.response });
        });
      }

      // 若state中已有會員帳號資料的promise，直接回傳
      return state.memberAccount;
    },
    // 取得生效之公司授權資訊
    getCompanyPermission({ rootState }) {
      const body = { companyID: rootState.companyId };
      return ssoService.getCompanyPermission(body)
        .toPromise();
    },
    // 取得會員 profile 設定
    getProfileSetting({ commit, rootState }, payload) {
      const params = {
        companyID: rootState.companyId,
        profileID: payload.id,
      };
      return ssoService.getProfileSetting(params)
        .toPromise()
        .then((res) => {
          if (res.response.success) {
            // 設定並排序 models
            const models = res.response.data[0].profiles.sort((a, b) => a.modelOrder - b.modelOrder);
            commit('setMemberSourceData', { id: 'models', value: models });
          }

          return res.response;
        });
    },
    // 取得客製化問題
    getCustomProfileSetting({ commit, rootState }, payload) {
      let language = '';
      const browserLanguage = navigator.language;
      switch (browserLanguage) {
        case 'zh-TW':
        case 'zh-CN':
          language = browserLanguage;
          break;
        default:
          language = 'en';
          break;
      }
      const body = {
        companyID: rootState.companyId,
        customProfileID: payload,
        language,
      };

      return mbcService.getCustomProfileSetting(body)
        .toPromise()
        .then((res) => {
          res.response.data.forEach((element) => {
            element.ans.forEach((element2) => {
              element2.value = element2.customAnsItemID;
              element2.text = element2.ansItem;
            });
          });

          commit('setMemberSourceData', { id: 'customModels', value: res.response.data });
          return res.response;
        });
    },
    // 取得會員資料
    getCustomerData({ commit, dispatch, rootState }) {
      const body = { companyID: rootState.companyId };

      return dispatch('getDigest', body).then((res) => {
        if (res.response.success) {
          const headers = {
            accessToken: rootState.accessToken,
            digest: res.response.data[0].digest,
          };

          return mbcService.getCustomerData(body, headers)
            .toPromise()
            .then((rsp) => {
              if (rsp.response.success) {
                commit('setAnswers', rsp.response.data[0]);
              }
              commit('setMemberSourceData', { id: 'customerData', value: rsp.response.data[0] });
              return rsp.response;
            });
        }

        return res.response;
      });
    },
    // 取得會員資料
    getCustomerDataMobile({ dispatch, rootState }, payload) {
      const body = { companyID: rootState.companyId, memberSourceID: rootState.memberSourceId, mobile: payload };

      return dispatch('getDigest', body).then((res) => {
        if (res.response.success) {
          const headers = {
            digest: res.response.data[0].digest,
          };
          return mbcService.getCustomerData(body, headers).toPromise();
        }
        return res.response;
      });
    },
    // 更新會員資料
    updateCustomerData({
      commit, dispatch, rootState, state,
    }) {
      commit('setMemberSourceData', { id: 'callPutCustomerdataupdateDone', value: false });
      const body = {
        companyID: rootState.companyId,
        memberSourceID: rootState.memberSourceId,
      };
      memberInfo.setModelsToBody(body, state);

      return dispatch('getDigest', body).then((res) => {
        if (res.response.success) {
          const headers = {
            accessToken: rootState.accessToken,
            digest: res.response.data[0].digest,
          };

          return mbcService.updateCustomerData(body, headers)
            .toPromise()
            .then((rsp) => {
              commit('setMemberSourceData', { id: 'callPutCustomerdataupdateDone', value: true });
              return rsp.response;
            });
        }

        return res.response;
      });
    },
    // 取得國家列表
    getCountrys({ commit }) {
      return ssoService.getCountrys()
        .toPromise()
        .then((res) => {
          const notCountry = 'ANO|ASIA|EU|EUR|MIDEAST|NAMER|SAMER';
          const notCountryArray = notCountry.split('|');
          const isCountry = res.response.data.filter((d) => {
            if (notCountry.indexOf(d.country) > -1) {
              for (let index = 0; index < notCountryArray.length; index += 1) {
                const element = notCountryArray[index];
                if (d.country === element) {
                  return false;
                }
              }
            }

            return true;
          });
          commit('setMemberSourceData', { id: 'countrys', value: isCountry });
        });
    },
    // 取得台灣縣市區列表
    getzipcode({ commit }) {
      return ssoService.getzipcode()
        .toPromise()
        .then((res) => {
          commit('setMemberSourceData', { id: 'twCityList', value: res.response.data });
        });
    },
    // 取得取得中國省市區列表
    getCNZipData(_, payload) {
      const params = {
        pid: payload,
      };

      return thirdPartyService.getCNZipData(params).toPromise();
    },
    // 驗證登入帳號密碼
    postAccountInfo({ rootState }, payload) {
      const body = {
        companyID: rootState.companyId,
        memberSourceID: rootState.memberSourceId,
        accountId: payload.accountID,
        password: payload.password,
      };
      return mbcService.postAccountInfo(body).toPromise();
    },
    getAccountVerifier({ rootState }, payload) {
      const params = {
        companyID: rootState.companyId,
        accountID: payload,
      };
      return mbcService.getAccountVerifier(params).toPromise();
    },
    postCustomerdataadd({ rootState }, payload) {
      const body = {
        companyID: rootState.companyId,
        memberSourceID: rootState.memberSourceId,
        accountType: payload.accountType,
        identifySource: payload.accountId,
        accountID: payload.accountId,
        callingCode: payload.callingCode,
        mobile: payload.mobile,
        mobileCountry: payload.mobileCountry,
        name: payload.accountId,
        verify: true,
        recommendId: rootState.memberId,
        activate: true,
      };
      return ssoService.getDigest(rootState.companyId, rootState.memberSourceId, body)
        .toPromise()
        .then((res) => {
          const header = { digest: res.response.data[0].digest };
          return mbcService.postCustomerdataadd(body, header).toPromise();
        }).catch((err) => err);
    },
    postMobileVerifyCode({ rootState }, payload) {
      const body = {
        companyID: rootState.companyId,
        memberSourceID: rootState.memberSourceId,
        verifyTarget: payload,
      };
      return ssoService.postMobileVerifyCode(body).toPromise();
    },
    postMobileVerifycodeVerifier({ rootState }, payload) {
      const body = {
        companyID: rootState.companyId,
        memberSourceID: rootState.memberSourceId,
        verifyTarget: payload.verifyTarget,
        verifyCode: payload.verifyCode,
      };
      return ssoService.postMobileVerifycodeVerifier(body).toPromise();
    },
    getMobileVerifySetting({ rootState }, payload) {
      const body = {
        companyID: rootState.companyid,
        paramCode: payload.limitedAgainSendTime,
      };
      return ssoService.getMobileVerifySetting(body).toPromise();
    },
    async postWording({ commit, rootState }) {
      let language = (navigator.language || navigator.userLanguage || '').toLowerCase();

      if (language !== 'zh-cn') {
        language = 'zh-tw';
      }

      return ssoService.postWording({
        companyId: rootState.companyId,
        memberSourceID: rootState.memberSourceId,
        language,
      }).toPromise().then((res) => {
        if (res && res.response && res.response.success && res.response.data && res.response.data[0]) {
          commit('set', { name: 'wording', value: res.response.data[0].param || [] });
        }
      });
    },
    putCustomizeCouponUsage({ rootState }, payload) {
      const body = {
        companyId: rootState.companyId,
        customerId: rootState.memberId,
        couponNo: payload.couponNo,
        orderSum: payload.orderSum,
        reimbursementCode: payload.reimbursementCode,
      };

      return pmtService.putCustomizeCouponUsage(body)
        .toPromise()
        .then((res) => res.response);
    },
    putWriteOffRedeemItem({ rootState }, payload) {
      const body = {
        companyId: rootState.companyId,
        orderNo: payload.orderNo,
        seqNo: payload.seqNo,
        reimbursementCode: payload.reimbursementCode,
      };
      const headers = {
        accessToken: rootState.accessToken,
      };
      return sctService.writeOffRedeemItemV2(body, headers)
        .toPromise()
        .then((res) => res.response);
    },
    postCustomizeCouponTransfer({ rootState }, payload) {
      const body = {
        companyID: rootState.companyId,
        memberIdFrom: payload.memberIdFrom,
        memberIdTo: payload.memberIdTo,
        couponNo: payload.couponNo,
      };
      return pmtService.postCustomizeCouponTransfer(body).toPromise();
    },
    getMemberAccountMemberId({ rootState }, payload) {
      const body = { companyID: rootState.companyId, accountID: payload };
      return mbcService.getMemberAccount(body).toPromise();
    },
    postMemberNotice(_, body) {
      return mbcService.postMemberNotice(body).toPromise();
    },
  },
};
